<template>
  <div>
    <page-heading-info
    title="Jefferson County Detention Center"
    phone="(740) 283-8684"
    fax="(740) 283-8695"
    >
      <address-simple
      line1="16001 State Route 7"
      line2="PO Box 549"
      line3="Steubenville, OH 43952"
      ></address-simple>
    </page-heading-info>

    <text-box-title title="General Info">
      <div class="col-md-6 mt-3">
        <p>
          We envision juvenile detention as a process not a place. We strive to create
          an environment in which personal accountability and responsibility are enhanced.
          Our programs are built upon the importance of education, competency, development,
          and social responsibility in the lives of children. Victims' rights, the social impact of
          crime, and consequences of delinquency are continually stressed. Our obligation is to
          help keep those communities and jurisdictions we serve safer.
        </p>
      </div>

      <div class="col-md-6 mt-3 margin-rows-0">
        <link-box class="margin-rows-0"
        bg-color="dark"
        dark="true"
        icon="book"
        icon-color="light"
        title-color="light"
        title="Parent Handbook"
        title-align="left"
        url="/static/departments/detention_center/Parent_Handbook.pdf">
          Rules and guidelines for parents
        </link-box>
      </div>
    </text-box-title>

    <text-box-title title="Visitation Schedule">
      <div class="col-md-6 mt-3">
        <icon-title
          title="Visiting Hours"
          icon="access_time"
          underline="true"
          ></icon-title>
        <p>
          Tuesday &amp; Wednesday: <span class="text-bold">3:30 pm - 4:30 pm</span>
        </p>

        <p>
        Thursday: <span class="text-bold">3:30 pm - 4:30 pm | 6:30 pm - 7:30 pm</span>
      </p>
      </div>

      <div class="col-md-6 mt-3">
        <icon-title
          title="Visitor Rules"
          icon="description"
          underline="true"
          ></icon-title>
        <p>
          Visitors are strictly limited to parents,
          grandparents, legal guardians or custodians.
        </p>

        <p>
        Visitors must schedule at least 24 hours in advance.
        <br />
        To schedule a visit, please call: <span class="text-bold">(740) 283-8684</span>
        </p>
      </div>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import IconTitle from '@/components/display-utils/IconTitle.vue'

export default {
  components: {
    PageHeadingInfo,
    AddressSimple,
    TextBoxTitle,
    LinkBox,
    IconTitle
  },
  data () {
    return {}
  },
  created: function() {
  },
  methods: {}
}
</script>

<style scoped>
  .court-lookup {
    font-size: 1.5em;
    font-weight: bold;
  }

  .court-lookup:hover {
    opacity: 0.7;
  }

</style>
